import React from 'react';
import classNames from 'classnames';
import { Icon } from '../Icon';
import styles from './InputRadio.module.scss';

interface InputRadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
	className?: string;
	label?: string | React.ReactNode;
	id: string;
	checked: boolean;
	variant?: 'default' | 'checkmark' | 'hidden';
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Generic InputRadio component, used for handling all radio type user input
 */
export const InputRadio: React.FunctionComponent<InputRadioProps> = ({
	className,
	id,
	label,
	checked,
	disabled,
	variant = 'default',
	onChange,
	...rest
}) => {
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		onChange(event);
	};

	return (
		<label className={classNames(styles.wrapperLabel, className)} htmlFor={id}>
			{typeof label === 'string' ? <div>{label}</div> : <>{label}</>}
			<input
				className={classNames(styles.input, 'u-hide-visually')}
				type="radio"
				checked={checked}
				id={id}
				onChange={handleChange}
				disabled={disabled}
				{...rest}
			/>
			{variant === 'checkmark' ? (
				<Icon className={styles.checkMarker} name={'checkFilled'} size={'md'} />
			) : variant !== 'hidden' ? (
				<span className={styles.radioMarker} />
			) : null}
		</label>
	);
};
